import { createAsyncThunk } from '@reduxjs/toolkit';

import { AlertId } from '../../types/alerts';
import {
  TrailsAlertCreateRequestPayload,
  TrailsAlertUpdateRequestPayload,
  TrailsAlertDeleteRequestPayload,
  createAlertRequest,
  updateAlertRequest,
  deleteAlertRequest,
  getAlertRequest
} from '../../utils/requests/alertRequests';

const createAlert = createAsyncThunk('alerts/post', async (trailsAlertRequestPayload: TrailsAlertCreateRequestPayload) => {
  const alertsCreated = await createAlertRequest(trailsAlertRequestPayload);
  return alertsCreated;
});

const updateAlert = createAsyncThunk('alerts/put', async (trailsAlertRequestPayload: TrailsAlertUpdateRequestPayload) => {
  const alert = await updateAlertRequest(trailsAlertRequestPayload);
  return alert;
});

const deleteAlert = createAsyncThunk('alerts/delete', async (trailsAlertRequestPayload: TrailsAlertDeleteRequestPayload) => {
  const alert = await deleteAlertRequest(trailsAlertRequestPayload);
  return alert;
});

const getAlert = createAsyncThunk('alerts/get', async (id: AlertId) => {
  const alerts = await getAlertRequest(id);
  return alerts[0];
});

export { createAlert, updateAlert, deleteAlert, getAlert };
